<template>
  <div class="blog__wrapper">
    <div class="blog__content">
      <div>
        <h2 v-if="post.welcomeScreenn">{{ post.title }}</h2>
        <h2 v-else>{{ post.title }}</h2>
        <p v-if="post.welcomeScreenn">{{ post.blogPostt }}</p>
        <p v-else class="content__prenpm runview">{{ post.blogHTML }}</p>
        <router-link class="link link-light" v-if="post.welcomeScreenn" to="#">
          الدخول / انشاء الحساب <Arrow class="arrow arrow-light" />
        </router-link>
        <router-link v-else class="link" to="#">
          أقرأ المنشور <Arrow class="arrow" />
        </router-link>
      </div>
    </div>
    <div class="blog__photo">
      <img
        v-if="post.welcomeScreenn"
        :src="require(`../src/assets/blogPhotos/${post.photo}.jpg`)"
        alt=""
      />
      <img
        v-else
        :src="require(`../src/assets/blogPhotos/${post.blogCoverPhoto}.jpg`)"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import Arrow from "../src/assets/Icons/arrow-left-light.svg";
export default {
  name: "blogPost",
  props: ["post"],
  components: {
    Arrow,
  },
};
</script>

<style lang="scss" scoped>
.blog__wrapper {
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  @media (min-width: 700px) {
    min-height: 650px;
    max-height: 650px;
    flex-direction: row;
  }
  .blog__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 4;
    order: 2;
    @media (min-width: 700px) {
      order: 1;
    }
    @media (min-width: 800px) {
      flex: 3;
    }
    div {
      max-width: 375px;
      padding: 72px 24px;
      @media (min-width: 700px) {
        padding: 0 24px;
      }
      h2 {
        font-size: 32px;
        font-weight: 300;
        text-transform: uppercase;
        margin-bottom: 24px;
        @media (min-width: 700px) {
          font-size: 43px;
        }
      }
      p {
        font-size: 21px;
        font-weight: 300;
        line-height: 1.7;
      }
      .content__preview {
        font-size: 21px;
        max-height: 35px;
        width: 250px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .link {
        display: inline-flex;
        align-items: center;
        margin-top: 32px;
        padding-bottom: 4px;
        border-bottom: 1px solid transparent;
        transition: 0.5s ease-in all;
        font-size: 19px;
        &:hover {
          border-bottom-color: #303030;
        }
      }
      .link-light {
        &:hover {
          border-bottom-color: #ffff;
        }
      }
    }
  }
  .blog__photo {
    order: 1;
    flex: 3;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
    @media (min-width: 700px) {
      order: 2;
    }
    @media (min-width: 800px) {
      flex: 3;
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &:nth-child(even) {
    .blog__content {
      order: 2;
    }
    .blog__photo {
      order: 1;
    }
  }
}
</style>
